const AdditionalRequestsList = async () =>
    import('../../pages/additional-requests/List').then((module) => ({
        Component: module.AdditionalRequestsList,
    }));
const AdditionalRequestView = async () =>
    import('../../pages/additional-requests/View').then((module) => ({
        Component: module.AdditionalRequestView,
    }));

// Modals
const CreateOrEditAdditionalRequestModal = async () =>
    import('../../pages/additional-requests/modal/CreateOrEditAdditionalRequestModal').then((module) => ({
        Component: module.CreateOrEditAdditionalRequestModal,
    }));
const UpdateAdditionalRequestStatusModal = async () =>
    import('../../pages/additional-requests/modal/UpdateAdditionalRequestStatusModal').then((module) => ({
        Component: module.UpdateAdditionalRequestStatusModal,
    }));
const UpdateAdditionalRequestServiceTypeModal = async () =>
    import('../../pages/additional-requests/modal/UpdateAdditionalRequestServiceTypeModal').then((module) => ({
        Component: module.UpdateAdditionalRequestServiceTypeModal,
    }));
const AssigneeAdditionalRequestModal = async () =>
    import('../../pages/additional-requests/modal/AssigneeAdditionalRequestModal').then((module) => ({
        Component: module.AssigneeAdditionalRequestModal,
    }));
const AcceptAdditionalRequestModal = async () =>
    import('../../pages/additional-requests/modal/AcceptAdditionalRequestModal').then((module) => ({
        Component: module.AcceptAdditionalRequestModal,
    }));
const RejectAdditionalRequestModal = async () =>
    import('../../pages/additional-requests/modal/RejectAdditionalRequestModal').then((module) => ({
        Component: module.RejectAdditionalRequestModal,
    }));
const DeleteAdditionalRequestModal = async () =>
    import('../../pages/additional-requests/modal/DeleteAdditionalRequestModal').then((module) => ({
        Component: module.DeleteAdditionalRequestModal,
    }));

const getAdditionalRequestRoutes = (user) => {
    if (user?.carrierId) return [];

    return [
        {
            paths: ['/additional-requests/', '/additional-requests/view/:viewId'],
            lazy: AdditionalRequestsList,
            children: [
                {
                    path: 'new',
                    lazy: CreateOrEditAdditionalRequestModal,
                },
            ],
        },
        {
            path: '/additional-requests/:additionalRequestId/',
            lazy: AdditionalRequestView,
            children: [
                {
                    path: 'edit',
                    lazy: CreateOrEditAdditionalRequestModal,
                },
                {
                    path: 'update-status',
                    lazy: UpdateAdditionalRequestStatusModal,
                },
                {
                    path: 'update-fees',
                    lazy: UpdateAdditionalRequestServiceTypeModal,
                },
                {
                    path: 'change-assignee',
                    lazy: AssigneeAdditionalRequestModal,
                },
                {
                    path: 'delete',
                    lazy: DeleteAdditionalRequestModal,
                },
                {
                    path: 'accept',
                    lazy: AcceptAdditionalRequestModal,
                },
                {
                    path: 'reject',
                    lazy: RejectAdditionalRequestModal,
                },
            ],
        },
    ];
};

export { getAdditionalRequestRoutes };
